import moment from 'moment';

export const fieldDataTypes = {
  string: 'string',
  number: 'number',
  array: 'array',
  date: 'date',
};

const symmetricDifference = (setA, setB) => {
  const difference = new Set(setA);

  for (const elem of setB) {
    if (difference.has(elem)) {
      difference.delete(elem);
    } else {
      difference.add(elem);
    }
  }

  return difference;
};

const compareStrategies = {
  [fieldDataTypes.string]: (init, current) => {
    const initVal = init?.trim();
    const currentVal = current?.trim();

    return initVal && currentVal && initVal === currentVal;
  },

  [fieldDataTypes.number]: (init, current) => {
    const hasInitVal = init !== null && init !== undefined;
    const hasCurrentVal = current !== null && current !== undefined;

    return hasInitVal && hasCurrentVal && init === current;
  },

  [fieldDataTypes.array]: (init, current) => {
    const hasInitVal = Array.isArray(init) && init.length > 0;
    const hasCurrentVal = Array.isArray(current) && current.length > 0;

    if (hasInitVal && hasCurrentVal) {
      const difference = symmetricDifference(new Set(init), new Set(current));

      return difference.size === 0;
    }

    return false;
  },

  [fieldDataTypes.date]: (init, current) => {
    const hasInitVal = moment.isMoment(init);
    const hasCurrentVal = moment.isMoment(current);

    return hasInitVal && hasCurrentVal && current.isSame(init, 'minute');
  },
};

export const compareWithInitVal =
  (initVal, type = fieldDataTypes.string) =>
  (_, value, callback) => {
    const compareStrategy = compareStrategies[type];

    if (compareStrategy && compareStrategy(initVal, value)) {
      callback('Значение не изменено');
    } else {
      callback();
    }
  };
